<template>
  <div class="PatientManager">
    <div class="topTitle">
      <p>添加患者</p>
    </div>
    <div class="mainBox">
      <div>
       <div>
         <span>患者基本信息</span>
       </div>
       <div class="mainInfo">
         <ul>
           <li>
             <p >
               <span class="redsize">病案号：</span>
             </p>
             <p>
               {{patientNo}}
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">姓名：</span>
             </p>
             <p>
               <Input v-model="name" placeholder="姓名" style="width: 300px" />
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">手机号：</span>
             </p>
             <p>
               <Input v-model="mobile" placeholder="手机号" style="width: 300px" />
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">性别：</span>
             </p>
             <p>
               <RadioGroup v-model="sex" >
                  <Radio v-for="(item,index) in sexList" :label="item.value" v-bind:key="index">{{item.label}}</Radio>
                </RadioGroup>
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">年龄：</span>
             </p>
             <p>
               <Input v-model="age" placeholder="年龄" style="width:100px;"/>
                <Select v-model="ageUnit" style="width:60px">
                  <Option v-for="item in ageUnitList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">身份证号：</span>
             </p>
             <p>
               <Input v-model="idNumber" placeholder="身份证号" style="width: 300px" />
             </p>
           </li>
           <li>
             <p>
               <span class="redsize">地址：</span>
             </p>
             <p>
               <Input v-model="address" placeholder="地址" style="width: 300px" />
             </p>
           </li>
         </ul>
       </div>
       <div class="btnBox">
         <Button @click="ok" type="primary">确定</Button>
         <Button @click="cancel">取消</Button>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  savePatient,updPatient,patientDetail
} from "../../api/patient";
import { tips,replaceT,payType } from "../../tools";
export default {
  name: 'AddPatient',
  data () {
    return {
      name:'',//名称
      patientNo:'0202230',//患者编号
      mobile:'',//手机号
      sex:1,
      sexList:[
        {
          label:'男',
          value:1
        },
        {
          label:'女',
          value:2
        }
      ],
      address:'',//地址
      idNumber:'',//身份证号
      age:'',//年龄
      ageUnit:'岁',//年龄单位
      ageUnitList:[
        {
          label:'岁',
          value:'岁'
        },
        {
          label:'个月',
          value:'个月'
        },
        {
          label:'天',
          value:'天'
        }
      ],
      ediltId:0,//修改id
    }
  },
  mounted(){
    this.loadList();
  },
  methods:{
    loadList(){
      let _this = this;
      _this.editId = _this.$route.query.editId;
      if(_this.editId){
        patientDetail({
          id:_this.editId
        }).then(res=>{
          console.log(res);
          _this.address = res.address;
          _this.age = res.age;
          _this.ageUnit = res.ageUnit;
          _this.idNumber = res.idNumber;
          _this.mobile = res.mobile;
          _this.name = res.name;
          _this.sex = res.sex;
        });
      }
    },
    ok(){
      let _this = this;
      if(this.editId==''){
        let params = {
          address: _this.address,
          age: _this.age,
          ageUnit:_this.ageUnit,
          idNumber: _this.idNumber,
          mobile: _this.mobile,
          name: _this.name,
          sex: _this.sex
        }
        if(params.name==''){
          tips(this,'姓名不能为空！','info');
        }else if(params.mobile==''){
          tips(this,'手机号不能为空！','info');
        }else if(params.age==''){
          tips(this,'年龄不能为空！','info');
        }else if(params.idNumber==''){
          tips(this,'身份证不能为空！','info');
        }else if(params.address==''){
          tips(this,'地址不能为空！','info');
        }else{
          savePatient(
            params
          ).then(res=>{
            console.log(res);
            tips(this,res,"success");
            this.$router.push({path:'patientdetail',query:{id:_this.editId}});
          });
        }
      }else{
        let params = {
          address: _this.address,
          age: _this.age,
          ageUnit:_this.ageUnit,
          idNumber: _this.idNumber,
          mobile: _this.mobile,
          name: _this.name,
          sex: _this.sex,
          id:_this.editId
        }
        if(params.name==''){
          tips(this,'姓名不能为空！','info');
        }else if(params.mobile==''){
          tips(this,'手机号不能为空！','info');
        }else if(params.age==''){
          tips(this,'年龄不能为空！','info');
        }else if(params.idNumber==''){
          tips(this,'身份证不能为空！','info');
        }else if(params.address==''){
          tips(this,'地址不能为空！','info');
        }else{
          updPatient(
            params
          ).then(res=>{
            console.log(res);
            tips(this,res,"success");
            this.$router.push({path:'patientdetail',query:{id:_this.editId}});
          });
        }
      }
      
    },
    cancel(){
      this.$router.push({path:'patientdetail',query:{id:this.editId}});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.PatientManager{
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
}
.topTitle{
  border-bottom: 1px solid #c9c9c9;
  height: 50px;
  line-height: 50px;
  
}
.topTitle>p{
  font-weight: bold;
  margin-left: 20px;
}
.mainBox{
  padding: 15px;
  background-color: #fff;
}
.mainBox>div{
  border: 1px solid #c9c9c9;
  padding: 0 10px 20px 10px;
}
.mainBox>div>div:first-child{
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #c9c9c9;
  padding-left: 20px;
}

.mainBox .mainInfo>ul>li{
  display: flex;
  justify-content: flex-start;
  height: 35px;
  line-height: 35px;
}
.mainBox .mainInfo>ul>li>p:nth-child(1){
  width: 18%;
  text-align: right;
}
.mainBox .mainInfo>ul>li>p>span{
  padding-left: 7px;
}
.mainBox .mainInfo>ul>li>p:nth-child(2){
  width: 88%;
}
.btnBox{
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
}
.btnBox>button:first-child{
  margin-left: 18%;
}
.btnBox>button:last-child{
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/patient/AddPatient.vue